module.exports = __webpack_public_path__ + "img/SOKAL-SRS-112921-DealerDraft-Infinity-4Playful.e658fa59.jpeg";